export const gridToScreen = ({
  gridX,
  gridY,
  tileSize,
  zoom,
  canvasWidth,
  canvasHeight,
  offsetX,
  offsetY,
}) => {
  const x = (gridX - gridY) * (tileSize / 2) * zoom + canvasWidth / 2 + offsetX;
  const y = (gridX + gridY) * (tileSize / 4) * zoom * -1 + canvasHeight / 2 + offsetY;
  return { x, y };
};

export const screenToGrid = ({
  clientX,
  clientY,
  canvasRect,
  canvasWidth,
  canvasHeight,
  offsetX,
  offsetY,
  zoom,
  tileSize,
}) => {
  // Convert CSS pixel pointer coordinates to the canvas's internal pixel space.
  const scaleX = canvasRect.width ? canvasWidth / canvasRect.width : 1;
  const scaleY = canvasRect.height ? canvasHeight / canvasRect.height : 1;
  const canvasX = (clientX - canvasRect.left) * scaleX;
  const canvasY = (clientY - canvasRect.top) * scaleY;

  const x = (canvasX - canvasWidth / 2 - offsetX) / zoom;
  const y = (canvasY - canvasHeight / 2 - offsetY) / zoom * -1;

  const gridX = Math.floor((x / (tileSize / 2) + y / (tileSize / 4)) / 2) + 1;
  const gridY = Math.floor((y / (tileSize / 4) - x / (tileSize / 2)) / 2) + 1;

  return { gridX, gridY };
};
